import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { IntegracaoLookupResponse } from '../../responses/integracao/integracao-lookup.response';

@Injectable({
  providedIn: 'root',
})
export class IntegracaoLookupService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  // A URL base para o controller ChaveAcesso, ajustada para o ambiente de integração.
  private readonly apiUrl = `${environment.urlApiIntegracao}Lookup`;

  /**
   * Lista as lookups do banco de integracao
   * Corresponde a: [HttpGet] /Lookup
   */
  public getLookups(): Observable<IntegracaoLookupResponse> {
    return this.httpClient
      .get<IntegracaoLookupResponse>(this.apiUrl, this.addHeaderToken() )
      .pipe(catchError(this.handleError));
  }
}